(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/coupon-static.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/coupon-static.js');
"use strict";

const {
  useMemo
} = React;
const {
  CouponStaticRow
} = svs.components.tipsen.couponStatic;
const {
  useGetDrawState
} = svs.components.tipsen.hooksWager;
const getPlayerBoardData = playerBet => {
  const boardData = {};
  if (playerBet) {
    boardData.signs = playerBet.boards.boardData.signs ? playerBet.boards.boardData.signs : playerBet.boards.boardData[0];
    boardData.mSigns = playerBet.boards.boardData.mSigns;
    boardData.uSigns = playerBet.boards.boardData.uSigns;
  }
  return boardData;
};

const CouponStatic = _ref => {
  let {
    alwaysIncludeParams,
    drawCompetitionId,
    drawEvents,
    drawIsCancelled,
    drawResults,
    drawNumber,
    productId,
    playerBet,
    sportType,
    isCompressed,
    selectedCouponChoice,
    distributionChoice,
    bestBetRow,
    changedEventNumbers = []
  } = _ref;
  const boardData = getPlayerBoardData(playerBet);
  const drawState = useGetDrawState(productId, drawNumber);
  const hasMSign = useMemo(() => {
    var _boardData$mSigns;
    return (_boardData$mSigns = boardData.mSigns) === null || _boardData$mSigns === void 0 ? void 0 : _boardData$mSigns.find(sign => sign);
  }, [boardData]);
  return React.createElement("div", {
    className: "pg_coupon_static ".concat(hasMSign ? 'pg_coupon_static--is-system' : '')
  }, React.createElement("ol", {
    className: "pg_coupon_static__event-groups"
  }, drawEvents.map(event => {
    var _playerBet$boards, _boardData$mSigns2, _boardData$signs, _playerBet$boards2, _boardData$uSigns;
    return React.createElement(CouponStaticRow, {
      alwaysIncludeParams: alwaysIncludeParams,
      bestBetRowResult: bestBetRow ? bestBetRow[event.eventNumber - 1] : undefined,
      betProperties: playerBet === null || playerBet === void 0 || (_playerBet$boards = playerBet.boards) === null || _playerBet$boards === void 0 ? void 0 : _playerBet$boards.betProperties,
      distributionChoice: distributionChoice,
      distributionForRow: distributionChoice === null || distributionChoice === void 0 ? void 0 : distributionChoice[event.eventNumber - 1],
      drawCompetitionId: drawCompetitionId,
      drawEvent: event,
      drawIsCancelled: drawIsCancelled,
      drawNumber: drawNumber,
      drawResult: drawResults ? drawResults[event.eventNumber - 1] : undefined,
      drawState: drawState,
      hasChangedResult: changedEventNumbers.includes(event.eventNumber),
      isCompressed: isCompressed,
      key: "".concat(drawNumber, "-").concat(event.eventNumber),
      mSign: (_boardData$mSigns2 = boardData.mSigns) === null || _boardData$mSigns2 === void 0 ? void 0 : _boardData$mSigns2[event.eventNumber - 1],
      playerBet: (_boardData$signs = boardData.signs) === null || _boardData$signs === void 0 ? void 0 : _boardData$signs[event.eventNumber - 1][0],
      productId: productId,
      selectedCouponChoice: selectedCouponChoice,
      sportType: sportType,
      systemType: playerBet === null || playerBet === void 0 || (_playerBet$boards2 = playerBet.boards) === null || _playerBet$boards2 === void 0 ? void 0 : _playerBet$boards2.systemType,
      uSign: (_boardData$uSigns = boardData.uSigns) === null || _boardData$uSigns === void 0 ? void 0 : _boardData$uSigns[event.eventNumber - 1]
    });
  })));
};
setGlobal('svs.components.tipsen.couponStatic.CouponStatic', CouponStatic);

 })(window);